<div class="my-2">
  <div class="mb-2 flex justify-between">
    <div class="mb-2 flex justify-between">
      <h1 class="text-lg font-bold">Danh mục sản phẩm</h1>
    </div>
  </div>
  <div class="bg-base-200 px-1 py-2">
    <section class="splide" #splide>
      <div class="splide__track">
        <ul class="splide__list">
          <li class="splide__slide">
            <div class="block cursor-pointer overflow-hidden">
              <div class="skeleton mx-auto h-24 w-24 rounded"></div>
              <div class="skeleton mx-auto my-2 h-4 w-16"></div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</div>
